import Wishlist from "../../slices/sales/wishlist/Wishlist"
import Cart from "../../slices/sales/cart/Cart"
import Order from "../../slices/sales/order/Order"
import ContactUs from "../../slices/sales/contact_us/ContactUs"

const salesReducer = {
    wishlist: Wishlist,
    cart: Cart,
    order: Order,
    contact_us: ContactUs,
};

export default salesReducer;